<template>
  <v-container ml-0 justify-lg align-lg>
    <v-card width="400">
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-subtitle>#{{ patient.warelineId }}</v-list-item-subtitle>
          <v-list-item-title class="text-h5 mb-1 text-h5 gray--text">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">{{ patient.name }}</span>
              </template>
              <span>{{ patient.name }}</span>
            </v-tooltip>
          </v-list-item-title>
          <v-list-item-subtitle>{{ patient.birthDate | moment("DD/MM/Y") }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-avatar tile size="45">
          <PatientPicture :avatar="patient.avatar" />
        </v-list-item-avatar>
      </v-list-item>

      <v-card-actions>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-on="on"
              :attrs="attrs"
              :to="`/pacientes/${patient.id}`"
            >
              <v-icon>eva-file-outline</v-icon>
            </v-btn>
          </template>
          <span>Histórico</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import PatientPicture from "@/components/queues/attendance/patient_picture.vue";
export default {
  name: "PatientListItem",
  components: {
    PatientPicture,
  },
  props: {
    patient: Object,
  },
};
</script>

<style lang="scss" scoped></style>

